import locale1b7ca4ce from '../../translations/german/index.ts'
import localed600f18c from '../../translations/french/index.ts'
import locale10766dd0 from '../../translations/english/index.ts'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {},
  vueI18nLoader: false,
  locales: [{"code":"de","iso":"de-DE","file":"german/index.ts","domain":"www.digitalcolliers.de"},{"code":"fr","iso":"fr-FR","file":"french/index.ts","domain":"www.digitalcolliers.fr"},{"code":"en","iso":"en-US","file":"english/index.ts","domain":"www.digitalcolliers.com"}],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "/workspace/translations/",
  rootRedirect: null,
  detectBrowserLanguage: false,
  differentDomains: true,
  baseUrl: "https://www.digitalcolliers.com",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"de","iso":"de-DE","file":"german/index.ts","domain":"www.digitalcolliers.de"},{"code":"fr","iso":"fr-FR","file":"french/index.ts","domain":"www.digitalcolliers.fr"},{"code":"en","iso":"en-US","file":"english/index.ts","domain":"www.digitalcolliers.com"}],
  localeCodes: ["de","fr","en"],
  additionalMessages: [],
}

export const localeMessages = {
  'german/index.ts': () => Promise.resolve(locale1b7ca4ce),
  'french/index.ts': () => Promise.resolve(localed600f18c),
  'english/index.ts': () => Promise.resolve(locale10766dd0),
}
